<div class="container mt-4">
  <div id="accordion" class=" col-lg-12">
    <div class="card"  *ngFor="let item of years; let itemNo=index">
      <div class="card-header" style="background-color:#9a8478;" id="headingOne">
        <h5 class="mb-0" >
          <button class="btn btn-link colorwhite"  data-toggle="collapse" [attr.data-target]="collapseId(item.publish_year+itemNo,true)" aria-expanded="true" [attr.aria-controls]="collapseId(item.publish_year+itemNo,false)">

            <!-- {{ item.publish_year}} -  -->
            {{item.jou_numbers[0].num_name}}
          </button>
        </h5>
      </div>
      <div id="{{collapseId(item.publish_year+itemNo,false)}}" class="collapse {{showClass(itemNo)}}" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body">
          <div>
            <!-- <div class="media position-relative">
              <div class="nav flex-column nav-pills" style="margin-right: 30px;" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <a class="nav-link {{activeClass(indexNo)}}" id="v-pills-home-tab" *ngFor="let jou_number of item.jou_numbers; let indexNo = index" data-toggle="pill" href="#{{jou_number.num_name}}" role="tab" aria-controls="v-pills-home" attr.aria-selected="{{indexNo == 0? true:false}}"> {{jou_number.num_name}} </a>
              </div>
              <div class="tab-content" id="v-pills-tabContent">
                <div class="tab-pane fade show {{activeClass(indexNo)}}" id="{{number.num_name}}" *ngFor="let number of item.jou_numbers; let indexNo = index" role="tabpanel" aria-labelledby="v-pills-home-tab">
                  
                </div>              
               
              </div>

          
            </div> -->


    <!-- --------tab buradan başlıyor ------------->

              <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">

                <li class="nav-item">
                  <a class="nav-link disabled bold font-weight-bold " style="font-size: 18px; color:#eebb48;">{{"issues" | translate }} :  </a>
                </li> 
                <li class="nav-item" *ngFor="let jouNumber of item.jou_numbers; let indexNo = index" >
                  <a class="nav-link {{activeClass(indexNo)}}" id="home-tab" data-toggle="tab" href="#{{jouNumber.num_name}}" role="tab" attr.aria-controls="{{jouNumber.num_name}}" aria-selected="true">{{jouNumber.num_issue}}</a>
                </li>            
         
              </ul>
              <!-- -----tab-content---------- -->
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade mb-5  {{showClass(indexNo)}} {{activeClass(indexNo)}}"  *ngFor="let number of item.jou_numbers; let indexNo = index" id="{{number.num_name}}" role="tabpanel" aria-labelledby="home-tab">
                    <div class="media">
                        <!-- <svg class="bd-placeholder-img mr-3" width="144" height="144" xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid slice" focusable="false" role="img"
                        aria-label="Generic placeholder image">
                        <title>Generic placeholder image</title>
                        <rect width="100%" height="100%" fill="#868e96"></rect>
                        </svg> -->
                        
                        <img width="144" class="d-none d-lg-block d-xl-none d-none d-xl-block" height="144" src="https://editorialgos.dpu.edu.tr/{{number.cover_photo}}">

                        <div class="media-body">
                          <br>
                          <h4 class="mt-0"  style="color:#eebb48">{{"issuesFiles" | translate }}</h4>
                          <!-- <a href="../../../assets/genel/sayi2_cover.jpeg" target="blank"> <p> {{"coverAdvisoryBoard" | translate}} </p>   </a>      -->
                          <a href="https://editorialgos.dpu.edu.tr/{{number.cover_photo}}" target="blank"> <p> {{"coverAdvisoryBoard" | translate}} </p>   </a>                         

                          <br>                        
          
                          <h4 class="mt-0" style="color:#eebb48">{{"articles" | translate }}</h4>
                          <ul class="list-group list-group-flush">
          
                            <li  class="list-group-item" *ngFor="let articl of number.articles">                    
                                          
                              <a href="{{articl.article_file_url}} " style="color:#125aa7">                
          
                                <svg width="1em" height="1em" style="font-size:30px;color:black" viewBox="0 0 16 16" class="bi bi-file-earmark-arrow-down" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"></path>
                                  <path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z"></path>
                                  <path fill-rule="evenodd" d="M8 6a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 10.293V6.5A.5.5 0 0 1 8 6z"></path>
                                </svg> 


                                  <span class="class" *ngIf="rootModel.language=='tr'">

                                    {{ articl.art_title | toTextCamelCase }}
          
                                  </span>
                               
                                  <span class="class" *ngIf="rootModel.language=='en'">

                                    {{ articl.art_title_lan2 | toTextCamelCase }}
          
                                  </span>
                              

                              </a>
                              <div class="text-right" style="margin: 8px 0 -8px 0;"><span  class="badge badge-info mr-2 bgYellow">{{"writers" | translate}}: </span>{{ articl.authors }}</div>
                            </li>
          
                          </ul>
                        </div>
                    </div>
                </div>
              </div>

  <!-------------- tab buradan bitiyor ------------->
         

          </div>


        </div>
      </div>
    </div>

  </div>
</div>

